import { Routes } from '@angular/router';
import { LandingComponent } from './landing.component';

export default [
    {
        path     : '',
        component: LandingComponent,
    },
    
] as Routes;
